import { Subcategory } from './types';

export const SYSTEM_TOOLS_SUBS: Record<string, Subcategory> = {
  SYS_TOOLS: {
    id: 'tools',
    titleKey: 'Tools.System.items.tools.title',
    icon: 'settings_suggest',
    path: '/system-tools/tools',
    docName: 'system_tools',
  },
  HARDWARE_TOOLS: {
    id: 'hardware',
    titleKey: 'Tools.System.items.hardware.title',
    icon: 'memory',
    path: '/system-tools/hardware',
    docName: 'hardware_tools',
  },
  WINDOWS_ISOS: {
    id: 'windows-isos',
    titleKey: 'Tools.System.items.windows-isos.title',
    icon: 'window',
    path: '/system-tools/windows-isos',
    docName: 'windows_isos',
  },
  CUSTOMIZATION: {
    id: 'customization',
    titleKey: 'Tools.System.items.customization.title',
    icon: 'palette',
    path: '/system-tools/customization',
    docName: 'customization',
  },
};

export const FILE_TOOLS_SUBS: Record<string, Subcategory> = {
  FILE_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.File.items.tools.title',
    icon: 'folder_zip',
    path: '/file-tools/tools',
    docName: 'file_tools',
  },
  PDF_TOOLS: {
    id: 'pdf',
    titleKey: 'Tools.File.items.pdf.title',
    icon: 'picture_as_pdf',
    path: '/file-tools/pdf',
    docName: 'pdf_tools',
  },
  FILE_TRANSFER: {
    id: 'transfer',
    titleKey: 'Tools.File.items.transfer.title',
    icon: 'move_up',
    path: '/file-tools/transfer',
    docName: 'file_transfer',
  },
  FILE_HOSTS: {
    id: 'hosts',
    titleKey: 'Tools.File.items.hosts.title',
    icon: 'cloud_upload',
    path: '/file-tools/hosts',
    docName: 'file_hosts',
  },
};

export const INTERNET_TOOLS_SUBS: Record<string, Subcategory> = {
  INET_TOOLS: {
    id: 'tools',
    titleKey: 'Tools.Internet.items.tools.title',
    icon: 'language',
    path: '/internet-tools/tools',
    docName: 'internet_tools',
  },
  RSS_TOOLS: {
    id: 'rss',
    titleKey: 'Tools.Internet.items.rss.title',
    icon: 'rss_feed',
    path: '/internet-tools/rss',
    docName: 'rss_tools',
  },
  SEARCH_TOOLS: {
    id: 'search',
    titleKey: 'Tools.Internet.items.search.title',
    icon: 'manage_search',
    path: '/internet-tools/search',
    docName: 'search_tools',
  },
  URL_TOOLS: {
    id: 'url',
    titleKey: 'Tools.Internet.items.url.title',
    icon: 'link',
    path: '/internet-tools/url',
    docName: 'url_tools',
  },
  EMAIL_TOOLS: {
    id: 'email',
    titleKey: 'Tools.Internet.items.email.title',
    icon: 'mail',
    path: '/internet-tools/email',
    docName: 'email_tools',
  },
  BROWSER_TOOLS: {
    id: 'browser',
    titleKey: 'Tools.Internet.items.browser.title',
    icon: 'browser_updated',
    path: '/internet-tools/browser',
    docName: 'browser_tools',
  },
  ARCHIVING: {
    id: 'archiving',
    titleKey: 'Tools.Internet.items.archiving.title',
    icon: 'archive',
    path: '/internet-tools/archiving',
    docName: 'archiving',
  },
  OSINT: {
    id: 'osint',
    titleKey: 'Tools.Internet.items.osint.title',
    icon: 'policy',
    path: '/internet-tools/osint',
    docName: 'osint',
  },
};

export const SOCIAL_TOOLS_SUBS: Record<string, Subcategory> = {
  SOCIAL_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.Social.items.tools.title',
    icon: 'groups',
    path: '/social-tools/tools',
    docName: 'social_tools',
  },
  DISCORD_REDDIT: {
    id: 'discord-reddit',
    titleKey: 'Tools.Social.items.discord-reddit.title',
    icon: 'forum',
    path: '/social-tools/discord-reddit',
    docName: 'discord_reddit',
  },
  TELEGRAM_YOUTUBE: {
    id: 'telegram-youtube',
    titleKey: 'Tools.Social.items.telegram-youtube.title',
    icon: 'smart_display',
    path: '/social-tools/telegram-youtube',
    docName: 'telegram_youtube',
  },
  BILIBILI_TWITCH: {
    id: 'bilibili-twitch',
    titleKey: 'Tools.Social.items.bilibili-twitch.title',
    icon: 'live_tv',
    path: '/social-tools/bilibili-twitch',
    docName: 'bilibili_twitch',
  },
  TWITTER_X: {
    id: 'twitter-x',
    titleKey: 'Tools.Social.items.twitter-x.title',
    icon: 'grid_3x3',
    path: '/social-tools/twitter-x',
    docName: 'twitter_x',
  },
  FB_INSTA: {
    id: 'facebook-instagram',
    titleKey: 'Tools.Social.items.facebook-instagram.title',
    icon: 'photo_camera',
    path: '/social-tools/facebook-instagram',
    docName: 'facebook_instagram',
  },
  BLOGGING_TOOLS: {
    id: 'blogging',
    titleKey: 'Tools.Social.items.blogging.title',
    icon: 'article',
    path: '/social-tools/blogging',
    docName: 'blogging_tools',
  },
  TUMBLR_FEDIVERSE: {
    id: 'tumblr-fediverse',
    titleKey: 'Tools.Social.items.tumblr-fediverse.title',
    icon: 'hub',
    path: '/social-tools/tumblr-fediverse',
    docName: 'tumblr_fediverse',
  },
  CHAN_TOOLS: {
    id: '4chan',
    titleKey: 'Tools.Social.items.4chan.title',
    icon: 'filter_alt',
    path: '/social-tools/4chan',
    docName: '4chan_tools',
  },
};

export const TEXT_TOOLS_SUBS: Record<string, Subcategory> = {
  TEXT_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.Text.items.tools.title',
    icon: 'text_fields',
    path: '/text-tools/tools',
    docName: 'text_tools',
  },
  TEXT_EDITORS: {
    id: 'editor',
    titleKey: 'Tools.Text.items.editor.title',
    icon: 'edit_note',
    path: '/text-tools/editor',
    docName: 'text_editor',
  },
  MARKUP_TOOLS: {
    id: 'markup',
    titleKey: 'Tools.Text.items.markup.title',
    icon: 'code',
    path: '/text-tools/markup',
    docName: 'markup_tools',
  },
  FONT_TOOLS: {
    id: 'fonts',
    titleKey: 'Tools.Text.items.fonts.title',
    icon: 'font_download',
    path: '/text-tools/fonts',
    docName: 'font_tools',
  },
};

export const GAMING_TOOLS_SUBS: Record<string, Subcategory> = {
  GAMING_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.Gaming.items.tools.title',
    icon: 'sports_esports',
    path: '/gaming-tools/tools',
    docName: 'gaming_tools',
  },
  STEAM_EPIC: {
    id: 'steam-epic',
    titleKey: 'Tools.Gaming.items.steam-epic.title',
    icon: 'videogame_asset',
    path: '/gaming-tools/steam-epic',
    docName: 'steam_epic',
  },
  GAME_DATABASES: {
    id: 'databases',
    titleKey: 'Tools.Gaming.items.databases.title',
    icon: 'storage',
    path: '/gaming-tools/databases',
    docName: 'gaming_databases',
  },
  MULTIPLAYER_TOOLS: {
    id: 'multiplayer',
    titleKey: 'Tools.Gaming.items.multiplayer.title',
    icon: 'groups_2',
    path: '/gaming-tools/multiplayer',
    docName: 'multiplayer_tools',
  },
  HOMEBREW_MINECRAFT: {
    id: 'homebrew-minecraft',
    titleKey: 'Tools.Gaming.items.homebrew-minecraft.title',
    icon: 'grass',
    path: '/gaming-tools/homebrew-minecraft',
    docName: 'homebrew_minecraft',
  },
  GENRE_SPECIFIC: {
    id: 'genre-specific',
    titleKey: 'Tools.Gaming.items.genre-specific.title',
    icon: 'category',
    path: '/gaming-tools/genre-specific',
    docName: 'genre_specific',
  },
  GAME_SPECIFIC: {
    id: 'game-specific',
    titleKey: 'Tools.Gaming.items.game-specific.title',
    icon: 'extension',
    path: '/gaming-tools/game-specific',
    docName: 'game_specific',
  },
};

export const IMAGE_TOOLS_SUBS: Record<string, Subcategory> = {
  IMAGE_EDITING: {
    id: 'editing',
    titleKey: 'Tools.Image.items.editing.title',
    icon: 'edit_square',
    path: '/image-tools/editing',
    docName: 'image_editing',
  },
  IMAGE_CREATION: {
    id: 'creation',
    titleKey: 'Tools.Image.items.creation.title',
    icon: 'brush',
    path: '/image-tools/creation',
    docName: 'image_creation',
  },
  DESIGN_RESOURCES: {
    id: 'design',
    titleKey: 'Tools.Image.items.design.title',
    icon: 'design_services',
    path: '/image-tools/design',
    docName: 'design_resources',
  },
  DOWNLOAD_IMAGES: {
    id: 'download',
    titleKey: 'Tools.Image.items.download.title',
    icon: 'image_search',
    path: '/image-tools/download',
    docName: 'download_images',
  },
  THREE_D_MODELS: {
    id: '3d',
    titleKey: 'Tools.Image.items.3d.title',
    icon: '3d_rotation',
    path: '/image-tools/3d',
    docName: '3d_models',
  },
  IMAGE_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.Image.items.tools.title',
    icon: 'image',
    path: '/image-tools/tools',
    docName: 'image_tools',
  },
  PHOTO_CAMERA: {
    id: 'camera',
    titleKey: 'Tools.Image.items.camera.title',
    icon: 'camera',
    path: '/image-tools/camera',
    docName: 'photo_camera',
  },
};

export const VIDEO_TOOLS_SUBS: Record<string, Subcategory> = {
  VIDEO_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.Video.items.tools.title',
    icon: 'video_library',
    path: '/video-tools/tools',
    docName: 'video_tools',
  },
  VIDEO_PLAYERS: {
    id: 'players',
    titleKey: 'Tools.Video.items.players.title',
    icon: 'play_arrow',
    path: '/video-tools/players',
    docName: 'video_players',
  },
  MEDIA_SERVERS: {
    id: 'servers',
    titleKey: 'Tools.Video.items.servers.title',
    icon: 'dns',
    path: '/video-tools/servers',
    docName: 'media_servers',
  },
  VIDEO_DOWNLOAD: {
    id: 'download',
    titleKey: 'Tools.Video.items.download.title',
    icon: 'download',
    path: '/video-tools/download',
    docName: 'video_download',
  },
  VIDEO_EDITING: {
    id: 'editing',
    titleKey: 'Tools.Video.items.editing.title',
    icon: 'movie_edit',
    path: '/video-tools/editing',
    docName: 'video_editing',
  },
};

export const AUDIO_TOOLS_SUBS: Record<string, Subcategory> = {
  AUDIO_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.Audio.items.tools.title',
    icon: 'headphones',
    path: '/audio-tools/tools',
    docName: 'audio_tools',
  },
  AUDIO_EDITING: {
    id: 'editing',
    titleKey: 'Tools.Audio.items.editing.title',
    icon: 'graphic_eq',
    path: '/audio-tools/editing',
    docName: 'audio_editing',
  },
  SYSTEM_AUDIO: {
    id: 'system',
    titleKey: 'Tools.Audio.items.system.title',
    icon: 'speaker',
    path: '/audio-tools/system',
    docName: 'system_audio',
  },
  ANDROID_AUDIO_TOOLS: {
    id: 'android',
    titleKey: 'Tools.Audio.items.android.title',
    icon: 'android',
    path: '/audio-tools/android',
    docName: 'android_audio',
  },
  IOS_AUDIO_TOOLS: {
    id: 'ios',
    titleKey: 'Tools.Audio.items.ios.title',
    icon: 'apple',
    path: '/audio-tools/ios',
    docName: 'ios_audio',
  },
};

export const EDUCATIONAL_TOOLS_SUBS: Record<string, Subcategory> = {
  EDU_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.Educational.items.tools.title',
    icon: 'school',
    path: '/educational-tools/tools',
    docName: 'educational_tools',
  },
  STUDY_RESEARCH: {
    id: 'research',
    titleKey: 'Tools.Educational.items.research.title',
    icon: 'microscope',
    path: '/educational-tools/research',
    docName: 'study_research',
  },
  FLASHCARDS_CALCS: {
    id: 'flashcards',
    titleKey: 'Tools.Educational.items.flashcards.title',
    icon: 'calculate',
    path: '/educational-tools/flashcards',
    docName: 'flashcards_calculators',
  },
  DICT_THESAURUS: {
    id: 'dictionaries',
    titleKey: 'Tools.Educational.items.dictionaries.title',
    icon: 'menu_book',
    path: '/educational-tools/dictionaries',
    docName: 'dictionaries_thesaurus',
  },
  ENCYCLOPEDIA: {
    id: 'encyclopedia',
    titleKey: 'Tools.Educational.items.encyclopedia.title',
    icon: 'auto_stories',
    path: '/educational-tools/encyclopedia',
    docName: 'encyclopedia',
  },
  WIKIPEDIA_TOOLS: {
    id: 'wikipedia',
    titleKey: 'Tools.Educational.items.wikipedia.title',
    icon: 'public',
    path: '/educational-tools/wikipedia',
    docName: 'wikipedia_tools',
  },
};

export const DEVELOPER_TOOLS_SUBS: Record<string, Subcategory> = {
  DEV_TOOLS_SUB: {
    id: 'tools',
    titleKey: 'Tools.Developer.items.tools.title',
    icon: 'terminal',
    path: '/developer-tools/tools',
    docName: 'developer_tools',
  },
  DEV_COMMUNITIES: {
    id: 'communities',
    titleKey: 'Tools.Developer.items.communities.title',
    icon: 'hub',
    path: '/developer-tools/communities',
    docName: 'dev_communities',
  },
  DEV_NEWS: {
    id: 'news',
    titleKey: 'Tools.Developer.items.news.title',
    icon: 'newspaper',
    path: '/developer-tools/news',
    docName: 'dev_news',
  },
  DEV_LEARNING_SUB: {
    id: 'learning',
    titleKey: 'Tools.Developer.items.learning.title',
    icon: 'laptop_chromebook',
    path: '/developer-tools/learning',
    docName: 'developer_learning',
  },
  GAME_DEV: {
    id: 'game-dev',
    titleKey: 'Tools.Developer.items.game-dev.title',
    icon: 'joystick',
    path: '/developer-tools/game-dev',
    docName: 'game_dev',
  },
  AI_TOOLS_DEV: {
    id: 'ai',
    titleKey: 'Tools.Developer.items.ai.title',
    icon: 'smart_toy',
    path: '/developer-tools/ai',
    docName: 'ai_tools',
  },
  IDES_EDITORS: {
    id: 'ides',
    titleKey: 'Tools.Developer.items.ides.title',
    icon: 'integration_instructions',
    path: '/developer-tools/ides',
    docName: 'ides_editors',
  },
  PROG_LANGS: {
    id: 'languages',
    titleKey: 'Tools.Developer.items.languages.title',
    icon: 'data_object',
    path: '/developer-tools/languages',
    docName: 'prog_langs',
  },
  WEB_DEV: {
    id: 'web',
    titleKey: 'Tools.Developer.items.web.title',
    icon: 'web',
    path: '/developer-tools/web',
    docName: 'web_development',
  },
  WEB_DEV_TOOLS: {
    id: 'web-tools',
    titleKey: 'Tools.Developer.items.web-tools.title',
    icon: 'developer_mode',
    path: '/developer-tools/web-tools',
    docName: 'web_dev_tools',
  },
  HOSTING_TOOLS: {
    id: 'hosting',
    titleKey: 'Tools.Developer.items.hosting.title',
    icon: 'cloud',
    path: '/developer-tools/hosting',
    docName: 'hosting_tools',
  },
  CYBERSECURITY_TOOLS: {
    id: 'cybersecurity',
    titleKey: 'Tools.Developer.items.cybersecurity.title',
    icon: 'admin_panel_settings',
    path: '/developer-tools/cybersecurity',
    docName: 'cybersecurity_tools',
  },
};

export const MEDIA_SUBS: Record<string, Subcategory> = {
  STREAMING: {
    id: 'streaming',
    titleKey: 'Media.features.streaming.title',
    icon: 'play_circle',
    path: '/media/streaming',
    docName: 'streaming',
  },
  LIVE_SPORT: {
    id: 'live-sport',
    titleKey: 'Media.features.liveSport.title',
    icon: 'sports_soccer',
    path: '/media/live-sport',
    docName: 'live_sport',
  },
  DOWNLOAD_SITES: {
    id: 'download-sites',
    titleKey: 'Media.features.downloadSites.title',
    icon: 'download',
    path: '/media/download-sites',
    docName: 'download_sites',
  },
  TORRENT: {
    id: 'torrent',
    titleKey: 'Media.features.torrent.title',
    icon: 'file_download',
    path: '/media/torrent',
    docName: 'torrent',
  },
  SUBTITLE_TOOLS: {
    id: 'subtitle-tools',
    titleKey: 'Media.features.subtitleTools.title',
    icon: 'subtitles',
    path: '/media/subtitle-tools',
    docName: 'subtitle_tools',
  },
  MEDIA_TRACKING: {
    id: 'media-tracking',
    titleKey: 'Media.features.mediaTracking.title',
    icon: 'analytics',
    path: '/media/media-tracking',
    docName: 'media_tracking',
  },
  MISC_MEDIA: {
    id: 'misc',
    titleKey: 'Media.features.misc.title',
    icon: 'more_horiz',
    path: '/media/misc',
    docName: 'misc',
  },
};

export const AI_SUBS: Record<string, Subcategory> = {
  AI_CHATBOTS: {
    id: 'chatbots',
    titleKey: 'AI.features.chatbots.title',
    icon: 'chat',
    path: '/ai/chatbots',
    docName: 'chatbots',
  },
  AI_WRITING: {
    id: 'writing',
    titleKey: 'AI.features.writing.title',
    icon: 'edit_note',
    path: '/ai/writing',
    docName: 'writing',
  },
  VIDEO_GEN: {
    id: 'video-gen',
    titleKey: 'AI.features.videoGen.title',
    icon: 'movie_edit',
    path: '/ai/video-gen',
    docName: 'video_gen',
  },
  IMAGE_GEN: {
    id: 'image-gen',
    titleKey: 'AI.features.imageGen.title',
    icon: 'palette',
    path: '/ai/image-gen',
    docName: 'image_gen',
  },
  AUDIO_GEN: {
    id: 'audio-gen',
    titleKey: 'AI.features.audioGen.title',
    icon: 'music_note',
    path: '/ai/audio-gen',
    docName: 'audio_gen',
  },
  AI_CODING: {
    id: 'coding',
    titleKey: 'AI.features.coding.title',
    icon: 'terminal',
    path: '/ai/coding',
    docName: 'coding',
  },
  AI_INDEXES: {
    id: 'indexes',
    titleKey: 'AI.features.indexes.title',
    icon: 'list_alt',
    path: '/ai/indexes',
    docName: 'indexes',
  },
  AI_BENCHMARKS: {
    id: 'benchmarks',
    titleKey: 'AI.features.benchmarks.title',
    icon: 'speed',
    path: '/ai/benchmarks',
    docName: 'benchmarks',
  },
};

export const DOWNLOADING_SUBS: Record<string, Subcategory> = {
  DL_SITES: {
    id: 'dl-sites',
    titleKey: 'Downloading.features.dlSites.title',
    icon: 'download',
    path: '/downloading/dl-sites',
    docName: 'download_sites',
  },
  SOFTWARE_SITES: {
    id: 'software-sites',
    titleKey: 'Downloading.features.softwareSites.title',
    icon: 'apps',
    path: '/downloading/software-sites',
    docName: 'software_sites',
  },
  USENET: {
    id: 'usenet',
    titleKey: 'Downloading.features.usenet.title',
    icon: 'group',
    path: '/downloading/usenet',
    docName: 'usenet',
  },
  DEBRID: {
    id: 'debrid',
    titleKey: 'Downloading.features.debrid.title',
    icon: 'bolt',
    path: '/downloading/debrid',
    docName: 'debrid',
  },
  TORRENT_SITES: {
    id: 'torrent-sites',
    titleKey: 'Downloading.features.torrentSites.title',
    icon: 'grid_view',
    path: '/downloading/torrent-sites',
    docName: 'torrent_sites',
  },
  TORRENT_CLIENTS: {
    id: 'torrent-clients',
    titleKey: 'Downloading.features.torrentClients.title',
    icon: 'settings_input_component',
    path: '/downloading/torrent-clients',
    docName: 'torrent_clients',
  },
  DL_OTHERS: {
    id: 'others',
    titleKey: 'Downloading.features.others.title',
    icon: 'more_horiz',
    path: '/downloading/others',
    docName: 'others',
  },
};

export const EDUCATIONAL_SUBS: Record<string, Subcategory> = {
  DOCUMENTARIES: {
    id: 'documentaries',
    titleKey: 'Educational.features.documentaries.title',
    icon: 'history_edu',
    path: '/educational/documentaries',
    docName: 'documentaries',
  },
  COURSES: {
    id: 'courses',
    titleKey: 'Educational.features.courses.title',
    icon: 'menu_book',
    path: '/educational/courses',
    docName: 'courses',
  },
  LEARNING_SITES: {
    id: 'learning-sites',
    titleKey: 'Educational.features.learningSites.title',
    icon: 'web',
    path: '/educational/learning-sites',
    docName: 'learning_sites',
  },
  SCIENCE_MATHS: {
    id: 'science-maths',
    titleKey: 'Educational.features.scienceMaths.title',
    icon: 'science',
    path: '/educational/science-maths',
    docName: 'science_maths',
  },
  SPACE: {
    id: 'space',
    titleKey: 'Educational.features.space.title',
    icon: 'rocket_launch',
    path: '/educational/space',
    docName: 'space',
  },
  HISTORY: {
    id: 'history',
    titleKey: 'Educational.features.history.title',
    icon: 'museum',
    path: '/educational/history',
    docName: 'history',
  },
  SKILLS_DIY: {
    id: 'skills-diy',
    titleKey: 'Educational.features.skillsDiy.title',
    icon: 'construction',
    path: '/educational/skills-diy',
    docName: 'skills_diy',
  },
  LANG_LEARNING: {
    id: 'lang-learning',
    titleKey: 'Educational.features.langLearning.title',
    icon: 'translate',
    path: '/educational/lang-learning',
    docName: 'lang_learning',
  },
  DEV_LEARNING: {
    id: 'dev-learning',
    titleKey: 'Educational.features.devLearning.title',
    icon: 'code',
    path: '/educational/dev-learning',
    docName: 'dev_learning',
  },
  EXAM_PREP: {
    id: 'exam-prep',
    titleKey: 'Educational.features.examPrep.title',
    icon: 'assignment',
    path: '/educational/exam-prep',
    docName: 'exam_prep',
  },
  EDU_TOOLS: {
    id: 'edu-tools',
    titleKey: 'Educational.features.eduTools.title',
    icon: 'calculate',
    path: '/educational/edu-tools',
    docName: 'edu_tools',
  },
};

export const MOBILE_SUBS: Record<string, Subcategory> = {
  ANDROID_APKS: {
    id: 'android-apks',
    titleKey: 'Mobile.features.androidApks.title',
    icon: 'android',
    path: '/mobile/android-apks',
    docName: 'android_apks',
  },
  ANDROID_DEVICE: {
    id: 'android-device',
    titleKey: 'Mobile.features.androidDevice.title',
    icon: 'smartphone',
    path: '/mobile/android-device',
    docName: 'android_device',
  },
  ANDROID_CAMERA: {
    id: 'android-camera',
    titleKey: 'Mobile.features.androidCamera.title',
    icon: 'photo_camera',
    path: '/mobile/android-camera',
    docName: 'android_camera',
  },
  EMULATORS_MOBILE: {
    id: 'emulators',
    titleKey: 'Mobile.features.emulators.title',
    icon: 'joystick',
    path: '/mobile/emulators',
    docName: 'emulators',
  },
  ANDROID_TORRENT: {
    id: 'android-torrent',
    titleKey: 'Mobile.features.androidTorrent.title',
    icon: 'file_download',
    path: '/mobile/android-torrent',
    docName: 'android_torrent',
  },
  ANDROID_AUDIO: {
    id: 'android-audio',
    titleKey: 'Mobile.features.androidAudio.title',
    icon: 'music_note',
    path: '/mobile/android-audio',
    docName: 'android_audio',
  },
  IOS_TOOLS: {
    id: 'ios-tools',
    titleKey: 'Mobile.features.iosTools.title',
    icon: 'phone_iphone',
    path: '/mobile/ios-tools',
    docName: 'ios_tools',
  },
  IOS_AUDIO: {
    id: 'ios-audio',
    titleKey: 'Mobile.features.iosAudio.title',
    icon: 'headphones',
    path: '/mobile/ios-audio',
    docName: 'ios_audio',
  },
  MOBILE_OTHERS: {
    id: 'others',
    titleKey: 'Mobile.features.others.title',
    icon: 'more_horiz',
    path: '/mobile/others',
    docName: 'others',
  },
};

export const DESKTOP_SUBS: Record<string, Subcategory> = {
  LINUX_GUIDE: {
    id: 'linux-guide',
    titleKey: 'Desktop.features.linuxGuide.title',
    icon: 'terminal',
    path: '/desktop/linux-guide',
    docName: 'linux_guide',
  },
  LINUX_APPS: {
    id: 'linux-apps',
    titleKey: 'Desktop.features.linuxApps.title',
    icon: 'grid_view',
    path: '/desktop/linux-apps',
    docName: 'linux_apps',
  },
  LINUX_TOOLS: {
    id: 'linux-tools',
    titleKey: 'Desktop.features.linuxTools.title',
    icon: 'settings_suggest',
    path: '/desktop/linux-tools',
    docName: 'linux_tools',
  },
  MAC_APPS: {
    id: 'mac-apps',
    titleKey: 'Desktop.features.macApps.title',
    icon: 'desktop_mac',
    path: '/desktop/mac-apps',
    docName: 'mac_apps',
  },
  MAC_TOOLS: {
    id: 'mac-tools',
    titleKey: 'Desktop.features.macTools.title',
    icon: 'build',
    path: '/desktop/mac-tools',
    docName: 'mac_tools',
  },
  UNIX_LIKE: {
    id: 'unix-like',
    titleKey: 'Desktop.features.unixLike.title',
    icon: 'computer',
    path: '/desktop/unix-like',
    docName: 'unix_like',
  },
};

export const READING_SUBS: Record<string, Subcategory> = {
  EBOOKS: {
    id: 'ebooks',
    titleKey: 'Reading.features.ebooks.title',
    icon: 'book',
    path: '/reading/ebooks',
    docName: 'ebooks',
  },
  SPECIAL_INTEREST_BOOKS: {
    id: 'special-interest',
    titleKey: 'Reading.features.specialInterest.title',
    icon: 'bookmark',
    path: '/reading/special-interest',
    docName: 'special_interest',
  },
  AUDIOBOOKS: {
    id: 'audiobooks',
    titleKey: 'Reading.features.audiobooks.title',
    icon: 'headset',
    path: '/reading/audiobooks',
    docName: 'audiobooks',
  },
  VISUAL_MEDIA_BOOKS: {
    id: 'visual-media',
    titleKey: 'Reading.features.visualMedia.title',
    icon: 'auto_stories',
    path: '/reading/visual-media',
    docName: 'visual_media',
  },
  EDUCATIONAL_BOOKS: {
    id: 'educational-books',
    titleKey: 'Reading.features.educationalBooks.title',
    icon: 'school',
    path: '/reading/educational-books',
    docName: 'educational_books',
  },
  DOCUMENTS: {
    id: 'documents',
    titleKey: 'Reading.features.documents.title',
    icon: 'description',
    path: '/reading/documents',
    docName: 'documents',
  },
  READING_OTHERS: {
    id: 'others',
    titleKey: 'Reading.features.others.title',
    icon: 'more_horiz',
    path: '/reading/others',
    docName: 'others',
  },
};

export const GAMING_SUBS: Record<string, Subcategory> = {
  DOWNLOAD_GAMES: {
    id: 'download-games',
    titleKey: 'Gaming.features.downloadGames.title',
    icon: 'download',
    path: '/gaming/download-games',
    docName: 'download_games',
  },
  SPECIAL_INTEREST_GAMING: {
    id: 'special-interest',
    titleKey: 'Gaming.features.specialInterest.title',
    icon: 'star',
    path: '/gaming/special-interest',
    docName: 'special_interest',
  },
  EMULATIONS_GAMING: {
    id: 'emulations',
    titleKey: 'Gaming.features.emulations.title',
    icon: 'videogame_asset',
    path: '/gaming/emulations',
    docName: 'emulations',
  },
  PUZZLES_TABLETOP: {
    id: 'puzzles',
    titleKey: 'Gaming.features.puzzles.title',
    icon: 'extension',
    path: '/gaming/puzzles',
    docName: 'puzzles',
  },
  BROWSER_GAMES: {
    id: 'browser-games',
    titleKey: 'Gaming.features.browserGames.title',
    icon: 'web',
    path: '/gaming/browser-games',
    docName: 'browser_games',
  },
};

export const PRIVACY_SECURITY_SUBS: Record<string, Subcategory> = {
  ADBLOCKING: {
    id: 'adblocking',
    titleKey: 'Privacy.features.adblocking.title',
    icon: 'block',
    path: '/privacy-security/adblocking',
    docName: 'adblocking',
  },
  ANTIVIRUS: {
    id: 'antivirus',
    titleKey: 'Privacy.features.antivirus.title',
    icon: 'security',
    path: '/privacy-security/antivirus',
    docName: 'antivirus',
  },
  PRIVACY_SECURITY: {
    id: 'privacy-security',
    titleKey: 'Privacy.features.privacySecurity.title',
    icon: 'lock',
    path: '/privacy-security/privacy-security',
    docName: 'privacy_security',
  },
  WEB_PRIVACY: {
    id: 'web-privacy',
    titleKey: 'Privacy.features.webPrivacy.title',
    icon: 'public_off',
    path: '/privacy-security/web-privacy',
    docName: 'web_privacy',
  },
  VPN: {
    id: 'vpn',
    titleKey: 'Privacy.features.vpn.title',
    icon: 'vpn_lock',
    path: '/privacy-security/vpn',
    docName: 'vpn',
  },
  PROXY: {
    id: 'proxy',
    titleKey: 'Privacy.features.proxy.title',
    icon: 'router',
    path: '/privacy-security/proxy',
    docName: 'proxy',
  },
};

export const AUDIO_SUBS: Record<string, Subcategory> = {
  AUDIO_STREAMING: {
    id: 'audio-streaming',
    titleKey: 'Audio.features.audioStreaming.title',
    icon: 'music_video',
    path: '/audio/audio-streaming',
    docName: 'audio_streaming',
  },
  SPECIALITY_STREAMING: {
    id: 'speciality-streaming',
    titleKey: 'Audio.features.specialityStreaming.title',
    icon: 'podcasts',
    path: '/audio/speciality-streaming',
    docName: 'speciality_streaming',
  },
  RADIO_STREAMING: {
    id: 'radio-streaming',
    titleKey: 'Audio.features.radioStreaming.title',
    icon: 'radio',
    path: '/audio/radio-streaming',
    docName: 'radio_streaming',
  },
  SPOTIFY_TOOLS: {
    id: 'spotify-tools',
    titleKey: 'Audio.features.spotifyTools.title',
    icon: 'album',
    path: '/audio/spotify-tools',
    docName: 'spotify_tools',
  },
  AUDIO_RIPPING: {
    id: 'audio-ripping',
    titleKey: 'Audio.features.audioRipping.title',
    icon: 'content_cut',
    path: '/audio/audio-ripping',
    docName: 'audio_ripping',
  },
  MEDIA_SOUNDTRACK: {
    id: 'soundtrack',
    titleKey: 'Audio.features.soundtrack.title',
    icon: 'audiotrack',
    path: '/audio/soundtrack',
    docName: 'soundtrack',
  },
  AUDIO_TRACKING: {
    id: 'tracking',
    titleKey: 'Audio.features.tracking.title',
    icon: 'query_stats',
    path: '/audio/tracking',
    docName: 'tracking',
  },
};

export const NON_ENGLISH_SUBS: Record<string, Subcategory> = {
  LANG_ARABIC: {
    id: 'arabic',
    titleKey: 'NonEnglish.features.arabic.title',
    icon: 'translate',
    path: '/non-english/arabic',
    docName: 'arabic',
  },
  LANG_BANGLA: {
    id: 'bangla',
    titleKey: 'NonEnglish.features.bangla.title',
    icon: 'translate',
    path: '/non-english/bangla',
    docName: 'bangla',
  },
  LANG_BULGARIAN: {
    id: 'bulgarian',
    titleKey: 'NonEnglish.features.bulgarian.title',
    icon: 'translate',
    path: '/non-english/bulgarian',
    docName: 'bulgarian',
  },
  LANG_CHINESE: {
    id: 'chinese',
    titleKey: 'NonEnglish.features.chinese.title',
    icon: 'translate',
    path: '/non-english/chinese',
    docName: 'chinese',
  },
  LANG_CZECH: {
    id: 'czech',
    titleKey: 'NonEnglish.features.czech.title',
    icon: 'translate',
    path: '/non-english/czech',
    docName: 'czech',
  },
  LANG_FILIPINO: {
    id: 'filipino',
    titleKey: 'NonEnglish.features.filipino.title',
    icon: 'translate',
    path: '/non-english/filipino',
    docName: 'filipino',
  },
  LANG_FRENCH: {
    id: 'french',
    titleKey: 'NonEnglish.features.french.title',
    icon: 'translate',
    path: '/non-english/french',
    docName: 'french',
  },
  LANG_GERMAN: {
    id: 'german',
    titleKey: 'NonEnglish.features.german.title',
    icon: 'translate',
    path: '/non-english/german',
    docName: 'german',
  },
  LANG_GREEK: {
    id: 'greek',
    titleKey: 'NonEnglish.features.greek.title',
    icon: 'translate',
    path: '/non-english/greek',
    docName: 'greek',
  },
  LANG_HEBREW: {
    id: 'hebrew',
    titleKey: 'NonEnglish.features.hebrew.title',
    icon: 'translate',
    path: '/non-english/hebrew',
    docName: 'hebrew',
  },
  LANG_HUNGARIAN: {
    id: 'hungarian',
    titleKey: 'NonEnglish.features.hungarian.title',
    icon: 'translate',
    path: '/non-english/hungarian',
    docName: 'hungarian',
  },
  LANG_INDIAN: {
    id: 'indian',
    titleKey: 'NonEnglish.features.indian.title',
    icon: 'translate',
    path: '/non-english/indian',
    docName: 'indian',
  },
  LANG_INDONESIAN: {
    id: 'indonesian',
    titleKey: 'NonEnglish.features.indonesian.title',
    icon: 'translate',
    path: '/non-english/indonesian',
    docName: 'indonesian',
  },
  LANG_ITALIAN: {
    id: 'italian',
    titleKey: 'NonEnglish.features.italian.title',
    icon: 'translate',
    path: '/non-english/italian',
    docName: 'italian',
  },
  LANG_JAPANESE: {
    id: 'japanese',
    titleKey: 'NonEnglish.features.japanese.title',
    icon: 'translate',
    path: '/non-english/japanese',
    docName: 'japanese',
  },
  LANG_KOREAN: {
    id: 'korean',
    titleKey: 'NonEnglish.features.korean.title',
    icon: 'translate',
    path: '/non-english/korean',
    docName: 'korean',
  },
  LANG_MALAY: {
    id: 'malay',
    titleKey: 'NonEnglish.features.malay.title',
    icon: 'translate',
    path: '/non-english/malay',
    docName: 'malay',
  },
  LANG_PERSIAN: {
    id: 'persian',
    titleKey: 'NonEnglish.features.persian.title',
    icon: 'translate',
    path: '/non-english/persian',
    docName: 'persian',
  },
  LANG_POLISH: {
    id: 'polish',
    titleKey: 'NonEnglish.features.polish.title',
    icon: 'translate',
    path: '/non-english/polish',
    docName: 'polish',
  },
  LANG_PORTUGUESE: {
    id: 'portuguese',
    titleKey: 'NonEnglish.features.portuguese.title',
    icon: 'translate',
    path: '/non-english/portuguese',
    docName: 'portuguese',
  },
  LANG_ROMANIAN: {
    id: 'romanian',
    titleKey: 'NonEnglish.features.romanian.title',
    icon: 'translate',
    path: '/non-english/romanian',
    docName: 'romanian',
  },
  LANG_RUSSIAN: {
    id: 'russian',
    titleKey: 'NonEnglish.features.russian.title',
    icon: 'translate',
    path: '/non-english/russian',
    docName: 'russian',
  },
  LANG_SLOVAK: {
    id: 'slovak',
    titleKey: 'NonEnglish.features.slovak.title',
    icon: 'translate',
    path: '/non-english/slovak',
    docName: 'slovak',
  },
  LANG_SPANISH: {
    id: 'spanish',
    titleKey: 'NonEnglish.features.spanish.title',
    icon: 'translate',
    path: '/non-english/spanish',
    docName: 'spanish',
  },
  LANG_SWEDISH: {
    id: 'swedish',
    titleKey: 'NonEnglish.features.swedish.title',
    icon: 'translate',
    path: '/non-english/swedish',
    docName: 'swedish',
  },
  LANG_THAI: {
    id: 'thai',
    titleKey: 'NonEnglish.features.thai.title',
    icon: 'translate',
    path: '/non-english/thai',
    docName: 'thai',
  },
  LANG_UKRANIAN: {
    id: 'ukranian',
    titleKey: 'NonEnglish.features.ukranian.title',
    icon: 'translate',
    path: '/non-english/ukranian',
    docName: 'ukranian',
  },
  LANG_UZBEK: {
    id: 'uzbek',
    titleKey: 'NonEnglish.features.uzbek.title',
    icon: 'translate',
    path: '/non-english/uzbek',
    docName: 'uzbek',
  },
  LANG_VIETNAMESE: {
    id: 'vietnamese',
    titleKey: 'NonEnglish.features.vietnamese.title',
    icon: 'translate',
    path: '/non-english/vietnamese',
    docName: 'vietnamese',
  },
  LANG_OTHER: {
    id: 'other',
    titleKey: 'NonEnglish.features.other.title',
    icon: 'translate',
    path: '/non-english/other',
    docName: 'other',
  },
};

export const MISCELLANEOUS_SUBS: Record<string, Subcategory> = {
  MISC_INDEXES: {
    id: 'indexes',
    titleKey: 'Miscellaneous.features.indexes.title',
    icon: 'list_alt',
    path: '/miscellaneous/indexes',
    docName: 'indexes',
  },
  MISC_FREE_STUFF: {
    id: 'free-stuff',
    titleKey: 'Miscellaneous.features.freeStuff.title',
    icon: 'redeem',
    path: '/miscellaneous/free-stuff',
    docName: 'free_stuff',
  },
  MISC_FOOD: {
    id: 'food',
    titleKey: 'Miscellaneous.features.food.title',
    icon: 'restaurant',
    path: '/miscellaneous/food',
    docName: 'food',
  },
  MISC_FASHION: {
    id: 'fashion',
    titleKey: 'Miscellaneous.features.fashion.title',
    icon: 'checkroom',
    path: '/miscellaneous/fashion',
    docName: 'fashion',
  },
  MISC_HOUSEHOLD: {
    id: 'household',
    titleKey: 'Miscellaneous.features.household.title',
    icon: 'home',
    path: '/miscellaneous/household',
    docName: 'household',
  },
  MISC_GARDENING: {
    id: 'gardening',
    titleKey: 'Miscellaneous.features.gardening.title',
    icon: 'yard',
    path: '/miscellaneous/gardening',
    docName: 'gardening',
  },
  MISC_VEHICLE: {
    id: 'vehicle',
    titleKey: 'Miscellaneous.features.vehicle.title',
    icon: 'directions_car',
    path: '/miscellaneous/vehicle',
    docName: 'vehicle',
  },
  MISC_SPORT: {
    id: 'sport',
    titleKey: 'Miscellaneous.features.sport.title',
    icon: 'sports_basketball',
    path: '/miscellaneous/sport',
    docName: 'sport',
  },
  MISC_TRAVEL: {
    id: 'travel',
    titleKey: 'Miscellaneous.features.travel.title',
    icon: 'flight',
    path: '/miscellaneous/travel',
    docName: 'travel',
  },
  MISC_MAPS: {
    id: 'maps',
    titleKey: 'Miscellaneous.features.maps.title',
    icon: 'map',
    path: '/miscellaneous/maps',
    docName: 'maps',
  },
  MISC_NEWS: {
    id: 'news',
    titleKey: 'Miscellaneous.features.news.title',
    icon: 'newspaper',
    path: '/miscellaneous/news',
    docName: 'news',
  },
  MISC_HEALTH: {
    id: 'health',
    titleKey: 'Miscellaneous.features.health.title',
    icon: 'health_and_safety',
    path: '/miscellaneous/health',
    docName: 'health',
  },
  MISC_CAREER: {
    id: 'career',
    titleKey: 'Miscellaneous.features.career.title',
    icon: 'work',
    path: '/miscellaneous/career',
    docName: 'career',
  },
  MISC_SHOPPING: {
    id: 'shopping',
    titleKey: 'Miscellaneous.features.shopping.title',
    icon: 'shopping_cart',
    path: '/miscellaneous/shopping',
    docName: 'shopping',
  },
  MISC_USEFUL_SITES: {
    id: 'useful-sites',
    titleKey: 'Miscellaneous.features.usefulSites.title',
    icon: 'auto_awesome',
    path: '/miscellaneous/useful-sites',
    docName: 'useful_sites',
  },
  MISC_FUN_SITES: {
    id: 'fun-sites',
    titleKey: 'Miscellaneous.features.funSites.title',
    icon: 'celebration',
    path: '/miscellaneous/fun-sites',
    docName: 'fun_sites',
  },
};

export const UNCATEGORISED_SUBS: Record<string, Subcategory> = {
  UNCATEGORISED_MOCKUPS: {
    id: 'app-site-mockups',
    titleKey: 'Uncategorised.features.appSiteMockups.title',
    icon: 'devices',
    path: '/uncategorised/app-site-mockups',
    docName: 'app_site_mockups',
  },
  UNCATEGORISED_CSS_FRAMEWORKS: {
    id: 'css-framework-tools',
    titleKey: 'Uncategorised.features.cssFrameworkTools.title',
    icon: 'css',
    path: '/uncategorised/css-framework-tools',
    docName: 'css_framework_tools',
  },
  UNCATEGORISED_DATA_VISUALIZATION: {
    id: 'data-visualization-tools',
    titleKey: 'Uncategorised.features.dataVisualizationTools.title',
    icon: 'insights',
    path: '/uncategorised/data-visualization-tools',
    docName: 'data_visualization_tools',
  },
  UNCATEGORISED_DESIGN_RESOURCES: {
    id: 'design-resources',
    titleKey: 'Uncategorised.features.designResources.title',
    icon: 'design_services',
    path: '/uncategorised/design-resources',
    docName: 'design_resources',
  },
  UNCATEGORISED_ART_COLLECTIONS: {
    id: 'digital-art-collections',
    titleKey: 'Uncategorised.features.digitalArtCollections.title',
    icon: 'photo_library',
    path: '/uncategorised/digital-art-collections',
    docName: 'digital_art_collections',
  },
  UNCATEGORISED_BRUSHES: {
    id: 'digital-brushes',
    titleKey: 'Uncategorised.features.digitalBrushes.title',
    icon: 'brush',
    path: '/uncategorised/digital-brushes',
    docName: 'digital_brushes',
  },
  UNCATEGORISED_DYNAMIC_DNS: {
    id: 'dynamic-dns',
    titleKey: 'Uncategorised.features.dynamicDns.title',
    icon: 'dns',
    path: '/uncategorised/dynamic-dns',
    docName: 'dynamic_dns',
  },
  UNCATEGORISED_EMULATORJS: {
    id: 'emulatorjs-neptunjs',
    titleKey: 'Uncategorised.features.emulatorjsNeptunjs.title',
    icon: 'sports_esports',
    path: '/uncategorised/emulatorjs-neptunjs',
    docName: 'emulatorjs_neptunjs',
  },
  UNCATEGORISED_DNS_RESOLVERS: {
    id: 'free-dns-resolvers',
    titleKey: 'Uncategorised.features.freeDnsResolvers.title',
    icon: 'security',
    path: '/uncategorised/free-dns-resolvers',
    docName: 'free_dns_resolvers',
  },
  UNCATEGORISED_VPN_CONFIGS: {
    id: 'free-vpn-configs',
    titleKey: 'Uncategorised.features.freeVpnConfigs.title',
    icon: 'vpn_lock',
    path: '/uncategorised/free-vpn-configs',
    docName: 'free_vpn_configs',
  },
  UNCATEGORISED_GEOMETRY_DASH: {
    id: 'geometry-dash-demon-lists',
    titleKey: 'Uncategorised.features.geometryDashDemonLists.title',
    icon: 'star',
    path: '/uncategorised/geometry-dash-demon-lists',
    docName: 'geometry_dash_demon_lists',
  },
  UNCATEGORISED_GIT_PROJECTS: {
    id: 'git-projects',
    titleKey: 'Uncategorised.features.gitProjects.title',
    icon: 'source',
    path: '/uncategorised/git-projects',
    docName: 'git_projects',
  },
  UNCATEGORISED_INTERNET_ARCHIVE: {
    id: 'internet-archive-tools',
    titleKey: 'Uncategorised.features.internetArchiveTools.title',
    icon: 'archive',
    path: '/uncategorised/internet-archive-tools',
    docName: 'internet_archive_tools',
  },
  UNCATEGORISED_JAPANESE_LEARNING: {
    id: 'japanese-learning-sites',
    titleKey: 'Uncategorised.features.japaneseLearningSites.title',
    icon: 'translate',
    path: '/uncategorised/japanese-learning-sites',
    docName: 'japanese_learning_sites',
  },
  UNCATEGORISED_LIBGEN_MIRRORS: {
    id: 'libgen-mirrors',
    titleKey: 'Uncategorised.features.libgenMirrors.title',
    icon: 'menu_book',
    path: '/uncategorised/libgen-mirrors',
    docName: 'libgen_mirrors',
  },
  UNCATEGORISED_LIBGEN_TOOLS: {
    id: 'libgen-tools',
    titleKey: 'Uncategorised.features.libgenTools.title',
    icon: 'construction',
    path: '/uncategorised/libgen-tools',
    docName: 'libgen_tools',
  },
  UNCATEGORISED_MANGA_DOWNLOADERS: {
    id: 'manga-downloaders',
    titleKey: 'Uncategorised.features.mangaDownloaders.title',
    icon: 'download',
    path: '/uncategorised/manga-downloaders',
    docName: 'manga_downloaders',
  },
  UNCATEGORISED_MANGA_READERS: {
    id: 'manga-readers',
    titleKey: 'Uncategorised.features.mangaReaders.title',
    icon: 'chrome_reader_mode',
    path: '/uncategorised/manga-readers',
    docName: 'manga_readers',
  },
  UNCATEGORISED_MEDIA_DB_TOOLS: {
    id: 'media-database-site-tools',
    titleKey: 'Uncategorised.features.mediaDatabaseSiteTools.title',
    icon: 'storage',
    path: '/uncategorised/media-database-site-tools',
    docName: 'media_database_site_tools',
  },
  UNCATEGORISED_MINECRAFT: {
    id: 'minecraft',
    titleKey: 'Uncategorised.features.minecraft.title',
    icon: 'layers',
    path: '/uncategorised/minecraft',
    docName: 'minecraft',
  },
  UNCATEGORISED_MULTIREDDITS: {
    id: 'multireddits',
    titleKey: 'Uncategorised.features.multireddits.title',
    icon: 'hub',
    path: '/uncategorised/multireddits',
    docName: 'multireddits',
  },
  UNCATEGORISED_MUSIC_SHEET: {
    id: 'music-sheet-collections',
    titleKey: 'Uncategorised.features.musicSheetCollections.title',
    icon: 'library_music',
    path: '/uncategorised/music-sheet-collections',
    docName: 'music_sheet_collections',
  },
  UNCATEGORISED_PNG_IMAGES: {
    id: 'png-images-clipart',
    titleKey: 'Uncategorised.features.pngImagesClipart.title',
    icon: 'photo',
    path: '/uncategorised/png-images-clipart',
    docName: 'png_images_clipart',
  },
  UNCATEGORISED_POLL_SITES: {
    id: 'poll-sites',
    titleKey: 'Uncategorised.features.pollSites.title',
    icon: 'poll',
    path: '/uncategorised/poll-sites',
    docName: 'poll_sites',
  },
  UNCATEGORISED_PRESENTATION_TOOLS: {
    id: 'presentation-tools',
    titleKey: 'Uncategorised.features.presentationTools.title',
    icon: 'co_present',
    path: '/uncategorised/presentation-tools',
    docName: 'presentation_tools',
  },
  UNCATEGORISED_PROXY_LISTS: {
    id: 'proxy-lists',
    titleKey: 'Uncategorised.features.proxyLists.title',
    icon: 'list',
    path: '/uncategorised/proxy-lists',
    docName: 'proxy_lists',
  },
  UNCATEGORISED_SELF_HOSTED_WIKI: {
    id: 'self-hosted-wiki-alts',
    titleKey: 'Uncategorised.features.selfHostedWikiAlts.title',
    icon: 'feed',
    path: '/uncategorised/self-hosted-wiki-alts',
    docName: 'self_hosted_wiki_alts',
  },
  UNCATEGORISED_SEARX_INSTANCES: {
    id: 'searx-instances',
    titleKey: 'Uncategorised.features.searxInstances.title',
    icon: 'search',
    path: '/uncategorised/searx-instances',
    docName: 'searx_instances',
  },
  UNCATEGORISED_SMS_VERIFICATION: {
    id: 'sms-verification-sites',
    titleKey: 'Uncategorised.features.smsVerificationSites.title',
    icon: 'sms',
    path: '/uncategorised/sms-verification-sites',
    docName: 'sms_verification_sites',
  },
  UNCATEGORISED_SURVIVAL: {
    id: 'survival',
    titleKey: 'Uncategorised.features.survival.title',
    icon: 'backpack',
    path: '/uncategorised/survival',
    docName: 'survival',
  },
  UNCATEGORISED_SVG_ICONS: {
    id: 'svg-icons',
    titleKey: 'Uncategorised.features.svgIcons.title',
    icon: 'category',
    path: '/uncategorised/svg-icons',
    docName: 'svg_icons',
  },
  UNCATEGORISED_TAB_MANAGERS: {
    id: 'tab-managers',
    titleKey: 'Uncategorised.features.tabManagers.title',
    icon: 'tab',
    path: '/uncategorised/tab-managers',
    docName: 'tab_managers',
  },
  UNCATEGORISED_TELEGRAM_EBOOK: {
    id: 'telegram-ebook-download',
    titleKey: 'Uncategorised.features.telegramEbookDownload.title',
    icon: 'send',
    path: '/uncategorised/telegram-ebook-download',
    docName: 'telegram_ebook_download',
  },
  UNCATEGORISED_TYPESCRIPT_TOOLS: {
    id: 'typescript-tools',
    titleKey: 'Uncategorised.features.typescriptTools.title',
    icon: 'integration_instructions',
    path: '/uncategorised/typescript-tools',
    docName: 'typescript_tools',
  },
  UNCATEGORISED_UDEMY_COUPONS: {
    id: 'udemy-coupons',
    titleKey: 'Uncategorised.features.udemyCoupons.title',
    icon: 'local_offer',
    path: '/uncategorised/udemy-coupons',
    docName: 'udemy_coupons',
  },
};
